$(document).ready(function () {
  //---------------------------------
  // hamburger menu
  //---------------------------------
  function hamburger() {
    const $html = $('html');
    const $burgerBtn = $('#js-hamburger-btn');

    $(window).on('resize', function () {
      if (
        window.matchMedia('(min-width: 1025px)').matches &&
        $html.hasClass('is-open--sidebar')
      ) {
        $html.removeClass('is-open--sidebar');
      }
    });

    $burgerBtn.on('touch click', function () {
      $html.toggleClass('is-open--sidebar');

      if ($(this).attr('aria-expanded') === 'false') {
        $(this).attr('aria-expanded', true);
      } else {
        $(this).attr('aria-expanded', false);
      }
    });
  }


  //---------------------------------
  // Smooth Scrolling (anchor link + go to top)
  //---------------------------------
  function smoothScrolling() {
    const $anchor = $('a[href^="#"]');

    if ($anchor.length) {
      $anchor.on('touch click', function () {
        $anchor.removeClass('is-current');

        let href = $(this).attr('href');
        let target = href == '#' || href == '' ? 'html' : href;
        let gap = 20;
        let position = $(target).offset().top - gap;

        $(this).addClass('is-current');

        $('html, body').stop().animate(
          {
            scrollTop: position,
          },
          'slow'
        );
        return false;
      });
    }
  }

  //---------------------------------
  // 初期化
  //---------------------------------
  function init() {
    hamburger();
    smoothScrolling();
  }

  init();
});
